'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useEffect, useId, useRef, useState } from 'react';
const TYPING_TEXT = 'AI 추천 맞춤정책은 어떠세요?';
const CYCLE_MS = 2_000;
const TYPE_SPEED = 50;
const DELETE_SPEED = 30;
export const AiAgentBanner = t0 => {
  const $ = _c(23);
  const {
    className,
    prefix: t1,
    bannerText: t2
  } = t0;
  const prefix = t1 === undefined ? "" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [TYPING_TEXT] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const bannerText = t3;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [text, setText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
  const currentText = bannerText[currentIndex];
  let t4;
  if ($[2] !== bannerText.length || $[3] !== currentText || $[4] !== isTyping || $[5] !== text) {
    t4 = () => {
      if (isTyping && text.length >= currentText.length) {
        const timer = setTimeout(() => setIsTyping(false), CYCLE_MS);
        return () => clearTimeout(timer);
      }
      if (!isTyping && text.length === 0) {
        const timer_0 = setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % bannerText.length);
          setIsTyping(true);
        }, CYCLE_MS / 2);
        return () => clearTimeout(timer_0);
      }
      const timer_1 = setTimeout(() => {
        setText(isTyping ? currentText.slice(0, text.length + 1) : text.slice(0, -1));
      }, isTyping ? TYPE_SPEED : DELETE_SPEED);
      return () => clearTimeout(timer_1);
    };
    $[2] = bannerText.length;
    $[3] = currentText;
    $[4] = isTyping;
    $[5] = text;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== bannerText || $[8] !== currentText || $[9] !== isTyping || $[10] !== text) {
    t5 = [text, isTyping, currentText, bannerText];
    $[7] = bannerText;
    $[8] = currentText;
    $[9] = isTyping;
    $[10] = text;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useEffect(t4, t5);
  const isTextEmpty = text.length === 0 && !prefix;
  const t6 = isTextEmpty && "gap-0";
  let t7;
  if ($[12] !== className || $[13] !== t6) {
    t7 = cn("inline-flex w-fit items-center gap-4 rounded-pill bg-Gray-white px-16 py-12 shadow-sm transition-colors typo-body4 hover:bg-Gray-50", t6, className);
    $[12] = className;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SvgAiSpark className="size-16 shrink-0" />;
    t9 = cn("whitespace-nowrap font-700", "text-Gray-700");
    $[15] = t8;
    $[16] = t9;
  } else {
    t8 = $[15];
    t9 = $[16];
  }
  let t10;
  if ($[17] !== prefix || $[18] !== text) {
    t10 = <span className={t9}>{prefix}{text}</span>;
    $[17] = prefix;
    $[18] = text;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7) {
    t11 = <div className={t7}>{t8}{t10}</div>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
export const SvgAiSpark = t0 => {
  const $ = _c(17);
  const {
    className,
    isAnimated: t1
  } = t0;
  const isAnimated = t1 === undefined ? true : t1;
  const gradientRef = useRef(null);
  const t2 = useId();
  let t3;
  if ($[0] !== t2) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /:/g;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    t3 = t2.replace(t4, "");
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const gradientId = t3;
  let t4;
  let t5;
  if ($[3] !== isAnimated) {
    t4 = () => {
      const gradient = gradientRef.current;
      if (!gradient) {
        return;
      }
      if (!isAnimated) {
        gradient.setAttribute("cx", "0%");
        gradient.setAttribute("cy", "30%");
        return;
      }
      let start = null;
      let animationId;
      const easeInOut = _temp;
      const animate = timestamp => {
        if (!start) {
          start = timestamp;
        }
        const progress = (timestamp - start) % 4000 / 4000;
        const t_0 = progress < 0.5 ? progress * 2 : 2 - progress * 2;
        const eased = easeInOut(t_0);
        gradient.setAttribute("cx", `${eased * 100}%`);
        gradient.setAttribute("cy", `${30 + eased * 40}%`);
        animationId = requestAnimationFrame(animate);
      };
      animationId = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationId);
    };
    t5 = [isAnimated];
    $[3] = isAnimated;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <stop offset="0%" stopColor="#FFD1EC" />;
    t7 = <stop offset="50%" stopColor="#80B0F8" />;
    t8 = <stop offset="100%" stopColor="#0090FF" />;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== gradientId) {
    t9 = <defs><radialGradient ref={gradientRef} id={gradientId} r="120%" cx="0%" cy="30%">{t6}{t7}{t8}</radialGradient></defs>;
    $[9] = gradientId;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = `url(#${gradientId})`;
  let t11;
  if ($[11] !== t10) {
    t11 = <path fill={t10} d="M5.84.61c.42-.81 1.73-.81 2.15 0 .57 1.09 1.3 2.31 2.11 3.12.8.81 2.03 1.55 3.12 2.11.81.42.81 1.74 0 2.16-1.09.56-2.32 1.3-3.12 2.1-.81.81-1.54 2.04-2.11 3.12-.42.81-1.73.81-2.15 0-.57-1.08-1.3-2.31-2.11-3.12-.81-.8-2.03-1.54-3.12-2.1-.81-.42-.81-1.74 0-2.16 1.09-.56 2.31-1.3 3.12-2.11.8-.81 1.54-2.03 2.11-3.12Z" />;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== className || $[14] !== t11 || $[15] !== t9) {
    t12 = <svg className={className} viewBox="0 0 14 14" fill="none">{t9}{t11}</svg>;
    $[13] = className;
    $[14] = t11;
    $[15] = t9;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
};
function _temp(t) {
  return t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2;
}